import { Container } from "@mantine/core";
import type { CustomLayout } from "next";
import { useRouter } from "next/router";
import { FooterMenu } from "src/layout/AppLayout/FooterMenu";
import { PageMainSearch } from "src/layout/AppLayout/PageMainSearch";
import { CustomFumufumuFormProvider } from "src/layout/FumufumuAppLayout/CustomFumufumuFormProvider";
import { FumufumuHeaderMemo } from "src/layout/FumufumuAppLayout/FumufumuHeader";

import styles from "../AppLayout/AppLayout.module.scss";
import { LayoutErrorBoundary } from "../LayoutErrorBoundary";

export const FumufumuAppLayout: CustomLayout = (page) => {
  const router = useRouter();

  return (
    <div
      className={
        router.pathname === "/fumufumu/[value]"
          ? styles.layout
          : styles.layoutWhite
      }
    >
      <CustomFumufumuFormProvider>
        <FumufumuHeaderMemo />
        <LayoutErrorBoundary>
          <Container className={styles.inner}>
            <PageMainSearch
              page={page}
              searchViewText="フムフムをキーワードやタグで検索できます"
            />
          </Container>
        </LayoutErrorBoundary>
        <FooterMenu />
      </CustomFumufumuFormProvider>
    </div>
  );
};
